<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="isLoading" class="no-top-space">
  <mic-breadcrumb class="mb-0">
    <mic-breadcrumb-link link="/home/dashboard" icon="home" ariaLabel="Home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/search-casings" [label]="translationService.translate('searchCasingsText')"></mic-breadcrumb-link>
  </mic-breadcrumb>
  <div class="flex justify-between items-center mb-3">
    <h2 class="m-0">{{ translationService.translate('casingsText') }}</h2>
    <div class="flex gap-3">
      <button mat-flat-button color="accent" (click)="clearFilters()">
        <mat-icon>refresh</mat-icon>
        {{ translationService.translate('clearSelectionText') }}
      </button>

      <button mat-flat-button color="primary" (click)="submitSearch()" [disabled]="isLoading">
        <mat-icon>search</mat-icon>
        {{ translationService.translate('searchButtonText') }}
      </button>
    </div>
  </div>

  <div>
    <form [formGroup]="searchCasingsForm">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder_open" fontSet="outlined"></mic-icon>
              {{ translationService.translate('searchByCasingSpecsText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider />
          <div class="flex items-start gap-4 mt-4">
            <mat-form-field appearance="fill" class="filter-item">
              <mat-label>{{ translationService.translate('searchByBarCodeNumberText') }}</mat-label>
              <input
                matInput
                formControlName="barcodeNumber"
                placeholder="{{ translationService.translate('enterBarcodeNumberText') }}"
                (keydown.enter)="submitSearch()"
              />
              <button id="search-barcode-num" disabled mat-icon-button matSuffix>
                <mat-icon class="mt-3 icon-display">search</mat-icon>
              </button>
            </mat-form-field>
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="casingMake"
                [data]="casingMakeList"
                [widthConfig]="{ width: '100%' }"
                placeholder="{{ translationService.translate('selectMakeText') }}"
                label="{{ translationService.translate('searchByMakeText') }}"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
              >
              </mic-dropdown-search>
            </div>
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="casingSeries"
                [data]="casingSeriesList"
                [widthConfig]="{ width: '100%' }"
                placeholder="{{ translationService.translate('selectSeriesText') }}"
                label="{{ translationService.translate('searchBySeriesText') }}"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
              >
              </mic-dropdown-search>
            </div>
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="casingSize"
                [data]="casingSizeList"
                [widthConfig]="{ width: '100%' }"
                placeholder="{{ translationService.translate('selectSizeText') }}"
                label="{{ translationService.translate('searchBySizeText') }}"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
              >
              </mic-dropdown-search>
            </div>
          </div>
          <div class="flex items-start gap-4 mt-2">
            <mat-form-field appearance="fill" class="filter-item">
              <mat-label>{{ translationService.translate('searchByMfgDotText') }}</mat-label>
              <input matInput formControlName="casingMfgDot" placeholder="{{ translationService.translate('enterMfgDotText') }}" />
              <button id="search-mfg-dot" disabled mat-icon-button matSuffix>
                <mat-icon class="mt-3 icon-display">search</mat-icon>
              </button>
            </mat-form-field>

            <mat-form-field appearance="fill" class="filter-item">
              <mat-label>{{ translationService.translate('searchByBrandNumberText') }}</mat-label>
              <input
                matInput
                formControlName="casingBrand"
                placeholder="{{ translationService.translate('enterBrandNumberText') }}"
                maxlength="25"
                (input)="onBrandNumberInput($event)"
              />
              @if (searchCasingsForm.get('casingBrand')?.hasError('maxlength')) {
              <mat-error>{{ translationService.translate('max25CharactersText') }}</mat-error>
              }
              <button id="search-brand" disabled mat-icon-button matSuffix>
                <mat-icon class="mt-3 icon-display">search</mat-icon>
              </button>
            </mat-form-field>

            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="casingTread"
                [data]="casingTreadList"
                placeholder="{{ translationService.translate('selectTreadText') }}"
                label="{{ translationService.translate('treadSearchText') }}"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [widthConfig]="{ width: '100%' }"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
              >
              </mic-dropdown-search>
            </div>

            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="casingTreadWidth"
                [data]="casingTreadWidthList"
                placeholder="{{ translationService.translate('selectTreadWidthText') }}"
                label="{{ translationService.translate('searchByTreadWidthText') }}"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [widthConfig]="{ width: '100%' }"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
              >
              </mic-dropdown-search>
            </div>
          </div>
          <div class="flex items-start gap-4 mt-2">
            <mat-form-field appearance="fill" class="filter-item">
              <mat-label>{{ translationService.translate('searchByNTRText') }}</mat-label>
              <input
                matInput
                inputmode="numeric"
                maxlength="1"
                pattern="^[0-9]$"
                type="text"
                formControlName="casingNtr"
                placeholder="{{ translationService.translate('enterNTRText') }}"
                (input)="onNtrInput($event)"
              />
              <button id="search-ntr" disabled mat-icon-button matSuffix>
                <mat-icon class="mt-3 icon-display">search</mat-icon>
              </button>
            </mat-form-field>
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="casingGrade"
                [data]="casingGradeList"
                placeholder="{{ translationService.translate('selectText') }} {{ translationService.translate('gradeText') }}"
                label="{{ translationService.translate('searchByText') }} {{ translationService.translate('gradeText') }}"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [widthConfig]="{ width: '100%' }"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
              >
              </mic-dropdown-search>
            </div>
            <mat-form-field appearance="fill" class="filter-item" subscriptSizing="dynamic">
              <mat-label>{{ translationService.translate('searchByText') + ' ' + translationService.translate('minBuffText') }}</mat-label>
              <input
                matInput
                type="text"
                inputmode="decimal"
                maxlength="10"
                formControlName="casingMinCircumference"
                placeholder="{{ translationService.translate('enterText') + ' ' + translationService.translate('minBuffText') }}"
                (input)="onCircumferenceInput($event, 'casingMinCircumference')"
              />
              @if (searchCasingsForm.get('casingMinCircumference')?.hasError('number')) {
              <mat-error>{{ translationService.translate('circumferenceInvalidNumberText') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" class="filter-item" subscriptSizing="dynamic">
              <mat-label>{{ translationService.translate('searchByText') + ' ' + translationService.translate('maxBuffText') }}</mat-label>
              <input
                matInput
                type="text"
                inputmode="decimal"
                maxlength="10"
                formControlName="casingMaxCircumference"
                placeholder="{{ translationService.translate('enterText') + ' ' + translationService.translate('maxBuffText') }}"
                [errorStateMatcher]="circumferenceRangeMatcher"
                (input)="onCircumferenceInput($event, 'casingMaxCircumference')"
              />
              @if (searchCasingsForm.get('casingMaxCircumference')?.hasError('number')) {
              <mat-error>{{ translationService.translate('invalidNumberText') }}</mat-error>
              } @else if (searchCasingsForm.hasError('circumferenceRange')) {
              <mat-error>{{ translationService.translate('circumferenceMinGreaterThanMaxText') }}</mat-error>
              }
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder_open" fontSet="outlined"></mic-icon>
              {{ translationService.translate('searchByLocAndStatusText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider />
          <div class="flex items-start gap-4 mt-4">
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="location"
                [data]="casingLocationList"
                placeholder="{{ translationService.translate('selectCasingLocationText') }}"
                label="{{ translationService.translate('searchByCasingLocationText') }}"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [widthConfig]="{ width: '100%' }"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
              >
              </mic-dropdown-search>
            </div>
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="post"
                [data]="postList"
                placeholder="{{ translationService.translate('selectPostText') }}"
                label="{{ translationService.translate('searchByPostText') }}"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [widthConfig]="{ width: '100%' }"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
              >
              </mic-dropdown-search>
            </div>
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="woSite"
                [data]="woSiteList"
                placeholder="{{ translationService.translate('selectWOSiteText') }}"
                label="{{ translationService.translate('searchByWOSiteText') }}"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [widthConfig]="{ width: '100%' }"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
              >
              </mic-dropdown-search>
            </div>
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="status"
                [data]="casingStatusList"
                placeholder="{{ translationService.translate('selectCasingStatusText') }}"
                label="{{ translationService.translate('searchByCasingStatusText') }}"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [widthConfig]="{ width: '100%' }"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
              >
              </mic-dropdown-search>
            </div>
            @if (showSequenceNumFilter) {
            <mat-form-field subscriptSizing="dynamic" class="filter-item">
              <mat-label>{{
                translationService.translate('searchByText') + ' ' + translationService.translate('sequenceNumberText')
              }}</mat-label>
              <input
                matInput
                inputmode="numeric"
                type="text"
                formControlName="sequenceNum"
                placeholder="{{ translationService.translate('enterSequenceNumText') }}"
              />
            </mat-form-field>
            }
          </div>
          <div class="flex items-start gap-4 mt-9">
            <div class="filter-item">
              <mic-dropdown-search
                micDropdownAccessibility
                formControlName="processCodes"
                [data]="processCodesList"
                placeholder="{{ translationService.translate('selectProcessCodesText') }}"
                label="{{ translationService.translate('searchByProcessCodeText') }}"
                searchPlaceholder="Search"
                subscriptSizing="dynamic"
                [multiple]="isMultiSelectTreadWidthGradeEnabled"
                [widthConfig]="{ width: '100%' }"
                [allLabel]="isMultiSelectTreadWidthGradeEnabled ? translationService.translate('selectAllText') : ''"
              >
              </mic-dropdown-search>
            </div>
            <mat-form-field subscriptSizing="dynamic" class="filter-item">
              <mat-label>{{ translationService.translate('customerCodeText') }}</mat-label>
              <input matInput type="text" formControlName="customerCode" autocomplete="off" />
              @if (customerCodeLookupLoading) {
              <mat-spinner matSuffix diameter="18"></mat-spinner>
              } @if (searchCasingsForm.get('customerCode')?.hasError('lookupFailed')) {
              <mat-error>{{ searchCasingsForm.get('customerCode')?.getError('lookupFailed') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic" class="filter-item text-field">
              <mat-label>{{ translationService.translate('customerNameText') }}</mat-label>
              <input matInput type="text" formControlName="customerName" autocomplete="off" readonly tabindex="-1" />
            </mat-form-field>
            <button
              mat-flat-button
              color="primary"
              class="mic-btn-icon-left"
              style="height: 56px"
              (click)="openCustomerModal()"
              type="button"
            >
              <mat-icon>search</mat-icon>
              <span>{{ translationService.translate('searchCustomerText') }}</span>
            </button>
          </div>
          <!-- No fields, just the header as requested -->
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder_open" fontSet="outlined"></mic-icon>
              {{ translationService.translate('searchByDateText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider />
          <div class="flex items-start gap-4 mt-4">
            <mat-form-field appearance="fill">
              <mat-label>{{
                translationService.translate('searchByText') +
                  ' ' +
                  translationService.translate('workOrderText') +
                  ' ' +
                  translationService.translate('creationDateText')
              }}</mat-label>
              <mat-date-range-input [rangePicker]="woCreatedRangePicker" class="my-date-range">
                <input
                  matStartDate
                  placeholder="{{ translationService.translate('selectCreationText') }}"
                  autocomplete="off"
                  formControlName="woCreatedDateStart"
                />
                <input
                  matEndDate
                  placeholder="{{ translationService.translate('dateRangeText') }}"
                  autocomplete="off"
                  formControlName="woCreatedDateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="woCreatedRangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #woCreatedRangePicker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>{{
                translationService.translate('searchByText') +
                  ' ' +
                  translationService.translate('workOrderText') +
                  ' ' +
                  translationService.translate('dueDateText')
              }}</mat-label>
              <mat-date-range-input [rangePicker]="woDueDatePicker">
                <input
                  matStartDate
                  placeholder="{{ translationService.translate('selectDueText') }}"
                  autocomplete="off"
                  formControlName="woDueDateStart"
                />
                <input
                  matEndDate
                  placeholder="{{ translationService.translate('dateRangeText') }}"
                  autocomplete="off"
                  formControlName="woDueDateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="woDueDatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #woDueDatePicker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>{{
                translationService.translate('searchByText') +
                  ' ' +
                  translationService.translate('casingText') +
                  ' ' +
                  translationService.translate('completeDateText')
              }}</mat-label>
              <mat-date-range-input [rangePicker]="casingCompleteDatePicker" class="my-date-range">
                <input
                  matStartDate
                  placeholder="{{ translationService.translate('selectCompletedText') }}"
                  autocomplete="off"
                  formControlName="casingCompleteDateStart"
                />
                <input
                  matEndDate
                  placeholder="{{ translationService.translate('dateRangeText') }}"
                  autocomplete="off"
                  formControlName="casingCompleteDateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="casingCompleteDatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #casingCompleteDatePicker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>{{
                translationService.translate('searchByText') +
                  ' ' +
                  translationService.translate('casingText') +
                  ' ' +
                  translationService.translate('receivedDateText')
              }}</mat-label>
              <mat-date-range-input [rangePicker]="casingReceivedDatePicker" class="my-date-range">
                <input
                  matStartDate
                  placeholder="{{ translationService.translate('selectReceivedText') }}"
                  autocomplete="off"
                  formControlName="casingReceivedDateStart"
                />
                <input
                  matEndDate
                  placeholder="{{ translationService.translate('dateRangeText') }}"
                  autocomplete="off"
                  formControlName="casingReceivedDateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="casingReceivedDatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #casingReceivedDatePicker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- ***uncomment the below once the section is ready to be implemented *** -->
      <!-- <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder_open" fontSet="outlined"></mic-icon>
              {{ translationService.translate('searchByRetreadAndRepairText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider />
        </mat-expansion-panel>
      </mat-accordion> -->
    </form>
  </div>
</mic-spinner-overlay>

<mic-modal #customerModal></mic-modal>
<ng-template #customerModalContent>
  <mic-customer-select-model
    [dealerId]="dealer?.id"
    [activeOnly]="true"
    [userLogin]="userLogin"
    [plantId]="plantId"
    (result)="onCustomerSelected($event)"
  >
  </mic-customer-select-model>
</ng-template>
